// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `::ng-deep .cdk-overlay-container {
  z-index: 9999 !important;
}
`, "",{"version":3,"sources":["webpack://./src/app/shared/components/custom-snack-bar/custom-snack-bar.component.css"],"names":[],"mappings":"AAAA;EACE,wBAAwB;AAC1B","sourcesContent":["::ng-deep .cdk-overlay-container {\r\n  z-index: 9999 !important;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
